import { render, staticRenderFns } from "./OrderRechazosTab.vue?vue&type=template&id=f5ca58f2&"
import script from "./OrderRechazosTab.vue?vue&type=script&lang=js&"
export * from "./OrderRechazosTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderRechazosTab.vue?vue&type=style&index=0&id=f5ca58f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports